<ng-template #returnOrderModal let-modal>
    <div class="modal-header">
        <h3 class="fw-semibold">Phiếu trả hàng cho đơn: {{order?.orderId}}</h3>
        <app-button [class]="'btn btn-close'" [spinner]="false" [id]="'address_modal_close_btn'"
            (click)="modal.dismiss('Cross click')">
            <i class="ri-close-line"></i>
        </app-button>
    </div>
    <div class="modal-body">
        <app-return-order [inputOrder]="order" (createSuccessEvt)="createSuccess($event)"></app-return-order>
    </div>
</ng-template>